module.exports = __webpack_public_path__ + "static/img/mlogo.ebef4af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mimg/mlogo.png
// module id = Y9BF
// module chunks = 4